import React, { useEffect, useState } from 'react'
import { Header } from 'components/layout/header'
import { Main } from 'components/layout/main'
import { Search } from 'components/search'
import { isBannerManager } from 'helpers/authentication'
import { bannersColumns } from 'helpers/banners-columns'
import { GenericDataTable } from 'helpers/generic-data-table'
import { fetchBanners, deleteBanner } from 'store/banners/bannersSlice'
import { getAllCustomBanners } from 'store/customBanners/customBannersSlice'
import { useAppDispatch, useAppSelector } from 'store/store'
import BannerForm from 'ui/components/BannerForm'

const BannersManagementPage: React.FC = () => {
  const dispatch = useAppDispatch()
  const { banners, totalPages } = useAppSelector((state) => state.banners)

  const [pageIndex, setPageIndex] = useState(0)
  const pageSize = 20

  // Options for the BannerForm picker
  useEffect(() => {
    dispatch(getAllCustomBanners())
  }, [dispatch])

  useEffect(() => {
    dispatch(fetchBanners(pageIndex + 1))
  }, [dispatch, pageIndex])

  return (
    <>
      {/* ===== Top Heading ===== */}
      <Header>
        <div className='ml-auto flex items-center space-x-4'>
          <Search />
        </div>
      </Header>

      {/* ===== Main ===== */}
      <Main>
        <div className='mb-2 flex flex-wrap items-center justify-between space-y-2 gap-x-4'>
          <div>
            <h2 className='text-2xl font-bold tracking-tight'>
              Gestione Banner
            </h2>
            <p className='text-muted-foreground'>
              Configura i banner che appariranno nei vari slot
            </p>
          </div>
        </div>
        <div className='-mx-4 mt-5 flex-1 overflow-auto px-4 py-1 lg:flex-row lg:space-y-0 lg:space-x-12'>
          <GenericDataTable
            columns={bannersColumns({
              onDeleteBanner: (bannerId) => {
                dispatch(deleteBanner(bannerId))
              },
            })}
            data={banners ?? []}
            pageCount={totalPages}
            pageIndex={pageIndex}
            pageSize={pageSize}
            onPageIndexChange={setPageIndex}
            toolbar={!isBannerManager() && <BannerForm />}
          />
        </div>
      </Main>
    </>
  )
}

export default BannersManagementPage
